"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _exportEntries = _interopRequireDefault(require("../entry-action-buttons/export-entries"));
var _addPostalEntry = _interopRequireDefault(require("./add-postal-entry"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _postalEntriesTable = _interopRequireDefault(require("./postal-entries-table"));
var _postalEntriesHelp = _interopRequireDefault(require("./postal-entries-help"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Loading...");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref3 = /*#__PURE__*/_react.default.createElement("h2", null, "Postal Entries");
var _ref4 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_postalEntriesHelp.default, null));
var _ref5 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "Existing Postal Entries are also displayed on Waiting List and Completed Entries Tabs");
class PostalEntries extends _react.Component {
  render() {
    if (!this.props.loaded) return _ref;
    const competition = this.props.competition;
    if (!competition.isAdministratedByUser) return _ref2;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref3, _ref4, /*#__PURE__*/_react.default.createElement(_exportEntries.default, {
      name: "postal-entries",
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID,
      useFreeCode: competition.useFreeCode
    }, "Export Postal Entries"), /*#__PURE__*/_react.default.createElement(_addPostalEntry.default, {
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID
    }), _ref5, /*#__PURE__*/_react.default.createElement(_postalEntriesTable.default, {
      useFreeCode: competition.useFreeCode,
      entries: competition.postalEntries
    }));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref6 = {
  id: true,
  yearID: true,
  isAdministratedByUser: true,
  useFreeCode: true,
  postalEntries: _mergeBqlQueries({}, _postalEntriesTable.default.partialQueries.Entry)
};
var _default = exports.default = (0, _reactBicycle.connect)(PostalEntries, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref6
}), undefined, {
  renderLoading: true
});